<template>
  <Modal :id="'cmp-settings-money-details-form'" @cancelled="onCancel" :loadingFlag="loadingFlag">
    <template slot="header"> {{title}} {{$t('cost_group_string')}}</template>

    <template slot="body">
      <div class="form-group">
        <TextField
          class="m1"
          :id="'cost_group_name'"
          v-bind="textFieldConfig"
          :value="cost_group.cost_group_name"
          :placeholder="$t('booking_loc_name')"
          @valuechanged="onTextFieldValueChange"
        />
        <Dropdown
          :options="targetsTV"
          class="m2"
          :selected="targetsTV.find(e => e.value == cost_group.target)"
          :placeholder="$t('target')"
          v-on:selectedChange="e => onDropdownChange('target', e)"
          :listHeight="95"
          box
        />
        <DTCheckbox
          :id="'advance_flag'"
          :label="$t('balance_type_1')"
          :checked="cost_group.advance_flag==1"
          @click="e=>onCheckboxChange('advance_flag',e)"
          :minH="'30px'"
          :class="'ml0'"
        />
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
      <button class="dt-button v1 s6" @click.stop="onFormSubmit">{{$t('ok')}}</button>
    </template>
  </Modal>
</template>

<script>
import Modal from '@dtplugins/modal/modal';
import { createFormModalMixin, createFormItemMixin } from '../../../../dt-plugins/form-modal/form-modal';
import { AccountingSettingsService } from '../../services/accounting-settings.service';
import DTCheckbox from "../../../../plugins/checkbox/checkbox";
export default {
  components: {
    Modal,
    DTCheckbox,
  },
  props: {

  },
  mixins: [
    createFormModalMixin(),
    createFormItemMixin({
      primary_key: 'cost_group_id',
      itemKey: 'cost_group',
      detailsHttpReq: AccountingSettingsService.findCostGroupDetails,
      addHttpReq: AccountingSettingsService.addCostGroupDetails,
    }),
  ],
  computed: {
    targetsTV: function() {
      return this.details?.targets?.map(t => ({
        text: this.$t(t.textkey),
        value: t.value,
      })) || [];
    }
  },
  methods: {
    get_cost_group: function() {
      return {
        identifier: '',
        income_flag: '',
        cost_group_id: '',
        created: '',
        last_modified: '',
        royalty_flag: '',
        target: '',
        cost_group_name: '',
        advance_flag: 0,
        cluster: ''
      };
    }
    //MARK: Methods
  }
};



</script>

<style lang="scss">
.cmp-settings-money-details-form {
  .dt-checkbox-control {
    display: flex;
    padding-top: 0px;
    margin-left: -8px;
    .dt-checkbox-label-container{
       margin-left: 5px;
    }
    .dt-checkbox {
      max-width: 40px;
      margin: 3px 10px 0px 0px;
    }
  }
}
</style>
